import ApplicationRecord from "./ApplicationRecord";

export default class NavItem extends ApplicationRecord({
  /**
   * @type {String}
   */
  id: -1,
  /**
   * Type of pages
   * @type {String}
   */
  type: "",
  /**
   * Navigation title
   * @type {String}
   */
  name: "",
  /**
   * Relative or absolute link
   * @type {String}
   */
  url: "",
  /**
   * Target _blank for opening in new tab
   * @type {String}
   */
  target: "",
  /**
   * @type {Boolean}
   */
  ShowInMenus: false,
  /**
   * @type {String} nav item icon if needded
   */
  Icon: "",
}) {}



// WEBPACK FOOTER //
// ./src/models/NavItem.js